<script lang="ts" setup>
  import { VueQueryDevtools } from '@tanstack/vue-query-devtools'

  import '~/assets/styles/index.css'
  import 'core-js/actual'

  const { suspensePrerequisite } = useAppInit()
  const { layout } = usePartner()
  const router = useRouter()
  const config = useRuntimeConfig()
  const scalable = config.public.isMobile ? ', minimum-scale=1.0, maximum-scale=1.0, user-scalable=no' : ''

  onServerPrefetch(async () => {
    await suspensePrerequisite()
  })

  useHead({
    title: 'Bookandgolf',
    meta: [
      {
        name: 'description',
        content: 'Bookandgolf - Application de réservation de parcours de golf',
      },
      {
        name: 'viewport',
        content: `width=device-width, initial-scale=1, viewport-fit=cover${scalable}`,
      },
    ],
  })

  onMounted(async () => {
    if (config.public.isMobile) {
      const { SplashScreen } = await import('@capacitor/splash-screen')
      const { App } = await import ('@capacitor/app')

      App.addListener('appUrlOpen', (data: { url: string }) => {
        const slug = data.url.split('bookandgolf:/').pop()
        if (slug) {
          router.push({
            path: slug,
          })
        }
      })
      await SplashScreen.hide()
    }
  })

</script>
<template>
  <NuxtLayout :name="layout">
    <NuxtPage />
  </NuxtLayout>
  <ClientOnly>
    <VueQueryDevtools />
  </ClientOnly>
</template>
